import loadable from '@loadable/component';

export const EmbedSearchWidgetViewVolopPageLoadable = loadable(
  () => import('./EmbedSearchWidgetViewVolopPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetViewVolopPage },
);
